export const GRIPPER_FORCE_NEWTONS_DEFAULT = 45;
export const GRIPPER_FORCE_PERCENT_DEFAULT = 0.5;
export const GRIPPER_GRIP_KIND_DEFAULT = 'inward';

// default diameter for the form should be accessible by any gripper
export const GRIPPER_DIAMETER_MM_DEFAULT = 45;
